import './index.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from '@/components/ui/toast'
import { TooltipProvider } from '@/components/ui/tooltip'
import { installGlobalErrorLogging } from '@/lib/log'
import { initNativeAuth } from '@/lib/native-auth'
import { SessionProvider } from '@/lib/session'
import { ThemeProvider } from '@/lib/theme'
import { App } from './App'
import { queryClient } from './router'

installGlobalErrorLogging()
void initNativeAuth()

const root = document.getElementById('root')
if (!root) throw new Error('missing #root')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <Toaster>
            <SessionProvider>
              <App />
            </SessionProvider>
          </Toaster>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
